import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Modal, FormGroup, FormControl/*, Tooltip, OverlayTrigger */} from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import Spinner from 'react-spinkit';

import ModalDropAssignment from '../common/ModalDropAssignment';
import * as courseActions from '../../actions/coursesActionCreators';
import * as runActions from '../../actions/runsActionCreators';
import * as studentActions from '../../actions/studentsActionCreators';
import { tableOptions as options } from '../../config';
import { bgColor } from '../common/Calendar/Event';
import { getClassesInRangeByFilters } from '../../utils/utils';
import { getCourseLocations } from '../../actions/commonActions';
import { LocationColumn } from '../rank/LocationRow'

class ClassesPage extends React.Component {
  state = {
    currentCourse: {},
    isOpenGrading: false,
    coursesLoaded: false,
    isOpenDrop: false,
    currentAssignment: {},
    pass_fail: false
  }

  componentWillMount() {
    if (!this.props.run.id) {
      this.props.runActions.getRun();
    }
    if (this.props.courses.length < 1) {
      this.props.courseActions.getAllCourses().then(() => {
        this.setState({ coursesLoaded: true });
      });
    } else {
      this.setState({ coursesLoaded: true });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.courses != this.props.courses) {
      this.setState({ coursesLoaded: true });
    }
  }

  openGrading = currentAssignment => () => {
    this.setState({
      isOpenGrading: true,
      currentAssignment,
      pass_fail: currentAssignment.pass_fail
    });
  };

  openDrop = currentAssignment => () => {
    this.setState({ isOpenDrop: true, currentAssignment });
  };

  handleClose = type => () => {
    this.setState({ [type]: false, pass_fail: null });
  };

  handleCloseDrop = () => {
    this.setState({
      isOpenDrop: false,
      pass_fail: null,
      currentAssignment: {}
    });
  }

  handleSubmitGrading = e => {
    e.preventDefault();
    const { currentAssignment, pass_fail } = this.state;
    if (currentAssignment.allow_pass_fail) {
      return this.props.courseActions
        .changeGrading(currentAssignment.id, pass_fail)
        .finally(() => this.setState({ isOpenGrading: false }));
    } else {
      alert('This assignment cannot change grading');
    }
  };

  parseAssignment = (items = []) => {
    const { courses = [], filteredDays } = this.props;
    if (courses.length === 0) return [];

    const parsedItems = items.map(item => {
      const course = courses.find(course => course.id === item.course) || {};

      const inRange = course && course.meetings.reduce((prev, curr) => {
        const { enddate, startdate } = curr;
        const classInRange = getClassesInRangeByFilters(startdate, enddate, filteredDays);

        return prev && classInRange;
      }, true);

      return {
        ...item,
        time: getCourseLocations(course),
        inRange,
        slug: course.slug,
        longname: course.longname,
        instructor: course.instructor,
        weight: course.weight,
        courseId: course.id,
        allow_pass_fail: course.allow_pass_fail,
        bgColor: this.isFavoriteClass(course.id) ? '#9b7eaf' : bgColor(course.id)
      };
    });

    const filteredItems = parsedItems.filter((i) => i.inRange);

    return filteredItems;
  };

  isFavoriteClass(courseId) {
    let favorite = false;
    this.props.student.preferences.map(pref => {
      if(pref.preference_class == 0 && pref.course == courseId) {
        favorite = true;
      }
    });
    return favorite;
  }

  formatGrading = (cell, row) => row.isOnGradingChange ? (
      <span className="color-gray">process…</span>
    ) : (
      <span>
        {row.pass_fail ? 'Pass/Fail ' : 'Letter '}
        {row.allow_pass_fail && (
          <a className="textColorPurple" onClick={this.openGrading(row)}>
            (Change)
          </a>
        )}
      </span>
    )

  formatDrop = (cell, row) => <i className="fa fa-trash" onClick={this.openDrop(row)} aria-hidden="true" />;

  formatName = (cell, row) => (
    <div>
      <i
        className="fa fa-circle"
        aria-hidden="true"
        style={{ color: row.bgColor, marginRight: '.5rem'}}
      />
      {cell}
    </div>
  );

  onGradingOptionChange = e => {
    this.setState({ pass_fail: e.target.value === 'pass_fail' });
  };

  formatTime(cell) {
    return ( <LocationColumn locations={cell} /> )
  }

  render() {
    const { coursesLoaded, currentAssignment, pass_fail, isOpenDrop } = this.state;
    const { student, run: { add_drop_open } } = this.props;
    const parseAssignment = this.parseAssignment(student.assignments);

    if (coursesLoaded)
      return <div>
          {parseAssignment.length > 0 ? <div className="c-table classes-table">
              <BootstrapTable data={parseAssignment} bordered={false} hover={true} condensed={true} options={options}>
                <TableHeaderColumn dataField="slug" isKey={true} dataSort={true} width="15%" dataFormat={this.formatName}>
                  Name
                </TableHeaderColumn>
                <TableHeaderColumn dataField="longname" dataSort={true} width="40%">
                  Description
                </TableHeaderColumn>
                <TableHeaderColumn dataField="instructor" dataSort={true} width="10%">
                  Instructor
                    </TableHeaderColumn>
                <TableHeaderColumn dataField="time" dataFormat={this.formatTime} dataSort={true} width="20%">
                  Time
                </TableHeaderColumn>
                <TableHeaderColumn dataField="weight" dataSort={true} width="10%">
                  Credits
                </TableHeaderColumn>
                { add_drop_open && [
                  <TableHeaderColumn dataField="pass_fail" dataSort={true} dataFormat={this.formatGrading} width="10%">
                    Grading
                  </TableHeaderColumn>
                ,
                  <TableHeaderColumn dataField="id" dataFormat={this.formatDrop} width="5%">
                    {''}
                  </TableHeaderColumn>
                ]}
              </BootstrapTable>
              <Modal show={this.state.isOpenGrading} onHide={this.handleClose('isOpenGrading')}>
                <Modal.Header closeButton>
                  <Modal.Title>
                    Change grading for {currentAssignment.slug}: {currentAssignment.longname}
                  </Modal.Title>
                </Modal.Header>
                <form onSubmit={this.handleSubmitGrading}>
                  <Modal.Body>
                    <FormGroup controlId="formControlsSelect">
                      <FormControl componentClass="select" placeholder="select" onChange={this.onGradingOptionChange}>
                        <option value="letter" selected={currentAssignment.pass_fail === false}>
                          Letter
                        </option>
                        <option value="pass_fail" selected={currentAssignment.pass_fail === true}>
                          Pass/Fail
                        </option>
                      </FormControl>
                    </FormGroup>
                  </Modal.Body>
                  <Modal.Footer>
                    <div className="buttonsSpaceBetween">
                      <button className="btn btn-ter" type="button" onClick={this.handleClose('isOpenGrading')}>
                        Cancel
                      </button>
                      <button
                        className="btn btn-primary"
                        type="submit"
                        disabled={pass_fail !== null && pass_fail === currentAssignment.pass_fail}
                      >
                        Change
                      </button>
                    </div>
                  </Modal.Footer>
                </form>
              </Modal>
              <ModalDropAssignment
                assignment={isOpenDrop && currentAssignment}
                onClose={this.handleCloseDrop}
                />
            </div> : <div className="text-center">No class</div>}
        </div>;
    return (
      <div className="spinner-box">
        <Spinner spinnerName="three-bounce" className="mt-4" />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    run: state.run,
    courses: state.courses,
    student: state.student
  };
}

function mapDispatchToProps(dispatch) {
  return {
    courseActions: bindActionCreators(courseActions, dispatch),
    runActions: bindActionCreators(runActions, dispatch),
    studentActions: bindActionCreators(studentActions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ClassesPage);



// WEBPACK FOOTER //
// ./src/components/classes/List.js